const ja = {
    9000001:"2023 クリスマス",
    9000002:"カップ - スーパーエックス・フューチャーズ",
    9000003:"トレーディング・コンペティション、賞金30,000USDTが当たる",
    9000004:"参加者数",
    9000005:"アンロック・ジャックポット（USDT）",
    9000006:"先物取引高ランキング予選会",
    9000007:"先物利回りランキング ",
    9000008:" プロフィットランキング予選",
    9000009:`最大 <span style="color: #ffc72b;">20,000</span> USDTのボーナスプールをアンロックする先物取引高ランキング大会 `,
    9000010:"参加者数に応じて賞金総額が増え、最大20,000USDTとなる。 ",
    9000011:"ジャックポット金額",
    9000012:"開催期間中、毎日10:00（UTC）に更新",
    9000013:"賞金見積もり ",
    9000014:"先物総取引高",
    9000015:"表彰規定 ",
    9000016:"参加者数に応じて賞金総額が増え、最大20,000USDTとなる。 ",
    9000017:"ジャックポット金額（USDT）",
    9000018:"活動収益率ランキング",
    9000019:"サインアップ",
    9000020:"活動の利益額ランキング",
    9000021:"終了",
    9000022:`先物利回りランキングコンテスト、賞金 <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000023:`利益ランキング大会、<span style="color: #ffc72b;">{moneyPond}</span> USDTボーナス`,
    9000024:"グロス先物利回り",
    9000025:"先物利益総額",
    9000026:"開始していません",
    9000027:"上位50名の参加者にはボーナス報酬が与えられます。ボーナス報酬を得るには、取引ランキング報酬ルールをご参照ください。",
    9000028:"先物利回りの上位50名の参加者には報酬が与えられます。報酬を得るには、取引ランキング報酬規則を参照してください。",
    9000029:"アクティビティ取引量ランキング",
    9000030:"登録に成功しました",
    9000031:"アプリをダウンロードする",
    9000032:"戻る首页",

    //合约交易积分
    9100001: 'ポイントを貯める',
    9100002: '空中投下を受ける',
    9100003: 'インセンティブ',
    9100004: 'ポイント残高',
    9100005: '詳細',
    9100006: 'チェックインポイント',
    9100007: '取引ポイント',
    9100008: 'ゆうどうせきぶん',
    9100009: 'ボーナスポイント',
    9100010: 'ラッキーくじ',
    9100011: 'ポイントの取得',
    9100012: 'せきぶんそく',
    9100013: '積分明細',
    9100014: 'このイベントに参加するには応募が必要で、クリックすれば参加できます',
    9100015: '{day}日連続取引を行い、{num}ポイントを獲得した',
    9100016: '今日得た {num} ポイント',
    9100017: 'せきぶんプール',
    9100018: '抽選ごとに {point} ポイントを消費し、1日最大 {num} 回引く',
    9100019: '本日の抽選回数',
    9100020: 'ユーザー',
    9100021: 'せきぶん',
    9100022: 'ポイント残高不足',
    9100023: 'ポイント残高が不足しておりますので、ポイントを取得してから抽選にご参加ください',
    9100024: '抽選回数が上限に達しました',
    9100025: '今日の抽選回数は上限に達しましたので、明日もう一度試してください。',
    9100026: 'ポイントの獲得方法',
    9100027: 'サインアップして契約取引ポイント獲得アクティビティに参加し、ポイントを獲得してください。',
    9100028: '参加申し込み成功',
    9100029: '契約取引に応募してポイントを獲得して、取引に行ってもっとポイントを獲得しましょう（コミッション還元奨励を受けなくなります）',
    9100030: '申し込みをキャンセルすると、ポイントはもらえなくなりますが、本当にキャンセルしますか。',
    9100031: '取引ポイント活動センター',
    9100032: 'ポイントの取得',
    9100033: 'このイベントに参加するには応募が必要で、クリックすれば参加できます',
    9100034: '契約に連続して参加することでポイントを得ることができます',
    9100035: 'ユーザーが契約市場で発生したすべての取引行為がポイントを取得することができます',
    9100036: 'ランキングポイント',
    9100037: '毎日の取引ランキング上位5位にボーナスポイントが追加される',
    9100038: '招待された人はポイントを生成し、招待者は奨励ポイントを得ることができる',
    9100039: '{guy} 当選済み<span style="color:#D9A31A"> {num} ポイント</span>',
    9100040: '今すぐくじを引く',
    9100041: 'ご獲得おめでとうございます',
    9100042: 'すべてのタイプ',
    9100043: 'このページにとどまります',
    9100044: '登録に参加する',
    9100045: '取引を続ける',
    9100046: '継続的な活動はありませんので、しばらくお待ちください...',
    9100047: 'SCS トークンを引き換える',
    9100048: '',
    9100049: '',

    9100050: '時間',
    9100051: 'スタート時間',
    9100052: '終了時間',
    9100053: 'に/まで',
    9100054: 'タイプ',

    9100055: '獲得ポイント = 取引量 * 1% (プラットフォームの総取引量が増加するにつれて、難易度はさらに調整されます)',
    9100056: '例: ユーザーは 100USDT*100X=10000U のマージンを持つポジションを使用します。',
    9100057: '100ポイントを獲得するには100USDTのデポジットのみが必要です',
    9100058: 'プラットフォームトークンSCSを入手するには取引ポイントが唯一の方法です',
    9100059: '追加ボーナスポイント＝当日の合計ポイント×ランキング報酬率',
    9100060: 'ランキング',
    9100061: '1位',
    9100062: '2位',
    9100063: '3位',
    9100064: '4位',
    9100065: '5位',
    9100066: '招待された人はポイントを生成し、招待者は奨励ポイントを得ることができる',
    9100067: '勾配係数',
    9100068: '計算式：獲得昇格ポイント＝招待者が獲得するポイント×レベル係数',
    9100069: 'レベル係数は実際の状況に応じて調整されます',
    9100070: '例: ユーザー B がポイント アクティビティに参加し、その招待者はユーザー A で、ユーザー A からの招待数はレベル 3 に達し、ユーザー B はポイント = 360,000 を蓄積しています。',
    9100071: 'ユーザー A が獲得できる累積プロモーション ポイント = 360000*30% = 108,000',
    9100072:'インセンティブ係数',
    9100073:'取引ユーザー1名',
    9100074:'トランザクション量が500Wに達する',
    9100075:'トランザクション量が2000Wに達する',

    9100076:'出入金',
}
export default  ja



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/ja.js